import { gql } from '@apollo/client'

// Same hand-written `updateShopSettingsV2` mutation as ProductSettings:
// `shopSettingsId` must always be sent (silent no-op without it).
// `pricelist_cover_imageId: null` clears the cover image.
export const GET_PRICELIST_SETTINGS = gql`
  query GET_PRICELIST_SETTINGS {
    findFirstShopSetting {
      id
      pricelist_export_enabled
      pricelist_cover_enabled
      pricelist_cover_imageId
      pricelist_cover_image {
        id
        src
      }
      pricelist_cover_terms
    }
  }
`

export const UPDATE_PRICELIST_SETTINGS = gql`
  mutation UPDATE_PRICELIST_SETTINGS(
    $shopSettingsId: Int
    $pricelist_export_enabled: Boolean
    $pricelist_cover_enabled: Boolean
    $pricelist_cover_imageId: Int
    $pricelist_cover_terms: String
  ) {
    updateShopSettingsV2(
      shopSettingsId: $shopSettingsId
      pricelist_export_enabled: $pricelist_export_enabled
      pricelist_cover_enabled: $pricelist_cover_enabled
      pricelist_cover_imageId: $pricelist_cover_imageId
      pricelist_cover_terms: $pricelist_cover_terms
    ) {
      id
      pricelist_export_enabled
      pricelist_cover_enabled
      pricelist_cover_imageId
      pricelist_cover_image {
        id
        src
      }
      pricelist_cover_terms
    }
  }
`
